import PropTypes from 'prop-types';
import React from 'react';

import { ERROR_TYPE_UI } from '../../lib/SentryClient';
import Logger from '../../tools/Logger';

const log = Logger.child({
  component: 'GenericErrorBoundary ',
  errorType: ERROR_TYPE_UI,
});

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Display fallback UI
    this.setState({ hasError: true });
    log.error({ obj: info }, `Uncaught exception in component: ${error && error.message}`);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}
